<template>
  <section class="container-fluid double-block">
    <div class="double-block__title">
      <h2>Des formations agréés pour taxi et vtc.</h2>
    </div>
    <div class="dark-grey-text double-block__articles">
      <ServiceFeatureBlock
        class="slide-left"
        title="Formations VTC"
        tone="secondary"
        :copy-html="copy.vtc"
      >
        <template #media>
          <img
            src="@/assets/pictures/room-out.webp"
            alt="the-room-of-vtc-formation"
            class="img-fluid"
            loading="lazy"
          />
        </template>

        <template #actions>
          <div @click="circleBtn('formation-vtc')" class="div-btn">
            <a href="#" v-on:click.prevent class="div-btn__link"
              >En savoir plus &raquo;</a
            >
          </div>
        </template>
      </ServiceFeatureBlock>

      <div class="hr-d"></div>

      <ServiceFeatureBlock
        class="slide-right"
        title="Formations Taxi"
        tone="primary"
        reverse
        :copy-html="copy.taxi"
      >
        <template #media>
          <img
            src="@/assets/pictures/room2.webp"
            alt="classroom-taxi"
            class="img-fluid"
            loading="lazy"
          />
        </template>

        <template #actions>
          <div @click="circleBtn('formation-taxi')" class="div-btn">
            <a
              href="#"
              v-on:click.prevent
              class="div-btn__link div-btn__link--alt"
              >En savoir plus &raquo;</a
            >
          </div>
        </template>
      </ServiceFeatureBlock>
    </div>
  </section>
</template>

<script>
import ServiceFeatureBlock from "@/components/services/ServiceFeatureBlock.vue";

const copy = {
  vtc: `L'<strong>Institut Taxi</strong> propose une variété de <strong>formations pour les conducteurs VTC en Île-de-France</strong>. <br />
La <strong class="formation-name">formation initiale</strong> permet d'obtenir la précieuse <strong>carte professionnelle VTC</strong>, indispensable pour exercer cette activité. <br />
La <strong class="formation-name">formation continue</strong> qui est obligatoire et prévue tous les 5 ans pour vous permettre de renouveler votre <strong>carte professionnelle VTC</strong>. <br />
La <strong class="formation-name">formation passerelle de VTC vers taxi</strong>, pour ceux qui souhaitent effectuer une transition vers le <strong>métier de chauffeur de taxi</strong>. <br />
Ces formations complètes et adaptées offrent aux candidats toutes les compétences nécessaires pour réussir dans le domaine du <strong>transport public particulier de personnes</strong> (<strong>T3P</strong>).`,
  taxi: `L'<strong>Institut Taxi</strong> offre une gamme de formations complètes pour les <strong>conducteurs de taxi en Île-de-France</strong>. <br />
La <strong class="formation-name-t">formation initiale</strong> prépare les candidats à obtenir leur <strong>carte professionnelle de taxi</strong>, indispensable pour exercer légalement cette profession. <br />
La <strong class="formation-name-t">formation continue</strong> proposée pour les <strong>conducteurs de taxi</strong>, conformément aux exigences légales, afin de mettre à jour leurs compétences et de rester au fait des nouvelles réglementations. <br />
Les <strong class="formation-name-t">formations mobilité</strong> pour élargir votre zone d'activité. Les <strong>conducteurs de taxi</strong> peuvent suivre des formations spécifiques pour ajouter les départements <strong>92</strong> et <strong>75</strong> à leur <strong>carte professionnelle taxi</strong>. <br />
La <strong class="formation-name-t">formation passerelle</strong> permettant aux conducteurs taxi de <strong>devenir vtc</strong>. Ces formations spécialisées offrent aux candidats tous les outils nécessaires pour réussir dans le domaine du <strong>transport public particulier de personnes</strong> (<strong>T3P</strong>) en tant que <strong>chauffeur de taxi professionnel</strong>.`,
};

export default {
  name: "HomeDoubleSection",
  components: {
    ServiceFeatureBlock,
  },
  data() {
    return {
      copy,
    };
  },
  mounted() {
    import("@/assets/globalJs/global.js").then((module) => {
      const { observeElements } = module;
      observeElements(".slide-right", ".slide-left");
    });
  },
  methods: {
    circleBtn(itemActif) {
      this.$router.push({
        path: "/formations-taxi-vtc",
        query: { itemActif: itemActif },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.double-block {
  padding: clamp(74px, 9vw, 108px) 20px clamp(92px, 11vw, 126px);

  @media screen and (min-width: 768px) {
    padding-inline: 28px;
  }

  @media screen and (min-width: 992px) {
    padding: clamp(88px, 9vw, 116px) clamp(28px, 4vw, 56px)
      clamp(110px, 10vw, 138px);
  }

  &__title {
    width: min(100%, 1040px);
    margin: 0 auto 44px;
    text-align: center;

    h2 {
      margin: 0;
      font-family: "Spartan", "Arial Black", Arial, sans-serif;
      font-weight: 700;
      color: $color-primary;
      font-size: clamp(1.56rem, 1.18rem + 0.98vw, 2.3rem);
      line-height: 1.02;
      letter-spacing: 0.03em;
      text-shadow: 0 1px 0 rgba(255, 255, 255, 0.88),
        0 14px 28px rgba(0, 42, 84, 0.08);
    }

    @media screen and (min-width: 992px) {
      margin-bottom: 56px;
    }
  }

  &__articles {
    width: min(100%, 1180px);
    margin: 0 auto;

    > .hr-d {
      width: 94px;
      height: 4px;
      margin: 34px auto 38px;
      border-radius: 999px;
      background: $color-secondary;
      opacity: 1;
      box-shadow: 0 10px 22px rgba(254, 185, 20, 0.18);

      @media screen and (min-width: 992px) {
        margin: 40px auto 44px;
      }
    }
  }
}

.div-btn {
  display: flex;
  justify-content: flex-start;

  &__link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 46px;
    padding: 0 18px;
    border-radius: 999px;
    background: $color-primary;
    color: $color-secondary;
    text-decoration: none;
    font-family: "adam";
    font-size: 0.78rem;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    box-shadow: 0 12px 24px rgba(0, 42, 84, 0.12);
    transition: transform 0.2s ease, box-shadow 0.2s ease,
      background-color 0.2s ease;

    &:hover {
      transform: translateY(-1px);
      color: $color-secondary;
      text-decoration: none;
      box-shadow: 0 16px 28px rgba(0, 42, 84, 0.16);
    }

    &--alt {
      background: $color-secondary;
      color: $color-primary;
      box-shadow: 0 12px 24px rgba(254, 185, 20, 0.18);

      &:hover {
        color: $color-primary;
        box-shadow: 0 16px 28px rgba(254, 185, 20, 0.22);
      }
    }
  }
}

.formation-name {
  color: $color-primary;
}

.formation-name-t {
  color: $color-secondary;
}

.slide-right.active {
  @include slide-right(1.2s);
}

.slide-left.active {
  @include slide-left(1.2s);
}
</style>
